export default "__VITE_ASSET__D3Mr3Pzu__"